import styled from 'styled-components';

export const List = styled.ul`
  list-style-type: '- ';
`;
